<template>
  <div id="payment">   
    <PaymentComponent></PaymentComponent>     
  </div>
</template>

<script>

  import PaymentComponent from '@/components/cust_components/cust_payment_component.vue';
  
  export default {
      name: 'PaymentView',
      data() {
          return {
          }
      },
      components: {     
        PaymentComponent,
      }
  }
</script>